import useDocumentTitle from '../hooks/useDocument';
import {useEffect, useState} from 'react';
import {useAppStore} from '../store';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import {Button} from '@mantine/core';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';
import {JobsListComponent} from '../components/jobs/JobsList.component';

function JobsView() {
  const {jobStore} = useAppStore();
  useDocumentTitle('Vacancies-Quality-Home-Healthcare');
  const [swclick, setSwClick] = useState(false);
  const [oaclick, setOaClick] = useState(false);
  const {loading, jobs} = jobStore.getters;

  const handleShow = () => setSwClick(true);
  const handleHide = () => setSwClick(false);
  const handleOaShow = () => setOaClick(true);
  const handleOaHide = () => setOaClick(false);
  useEffect(() => {
    jobStore.actions.loadJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="body-wrapper">
      <Header />

      <div className="ltn__page-details-area ltn__service-details-area mb-3 pt-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="color-border mb-3"></div>
              <h2 className="text-left compassion mt-5">
                Current opportunities
              </h2>
              <p className="values_p mb-3">
                Below is a list of current opportunities. Use the filters on
                this page to narrow these listings.
              </p>
              <h3 className="text-left compassion">Vacancy filters</h3>
              <h6>Type of Role</h6>
              <div className="row">
                <div className="p-2 col-lg-3 col-md-4 col-sm-6">
                  {!swclick ? (
                    <Button
                      variant="outline"
                      color="gray"
                      size="lg"
                      onClick={handleShow}
                    >
                      Support Worker
                    </Button>
                  ) : (
                    <Button
                      size="lg"
                      onClick={handleHide}
                      styles={theme => ({
                        root: {
                          backgroundColor: '#21485e',
                          border: 0,

                          '&:not([data-disabled])': theme.fn.hover({
                            backgroundColor: '#21485e',
                            color: '#ffffff',
                          }),
                        },
                      })}
                    >
                      Support Worker
                    </Button>
                  )}
                </div>
                <div className="p-2 col-lg-3 col-md-4 col-sm-6">
                  {!oaclick ? (
                    <Button
                      variant="outline"
                      color="gray"
                      size="lg"
                      onClick={handleOaShow}
                    >
                      Office / Admin
                    </Button>
                  ) : (
                    <Button
                      size="lg"
                      onClick={handleOaHide}
                      styles={theme => ({
                        root: {
                          backgroundColor: '#21485e',
                          border: 0,

                          '&:not([data-disabled])': theme.fn.hover({
                            backgroundColor: '#21485e',
                            color: '#ffffff',
                          }),
                        },
                      })}
                    >
                      Office / Admin
                    </Button>
                  )}
                </div>

                <div className="p-2 col-lg-3 col-md-4 col-sm-6">
                  <Button variant="outline" color="gray" size="lg">
                    Management
                  </Button>
                </div>

                <div className="p-2 col-lg-3 col-md-4 col-sm-6">
                  <Button variant="outline" color="gray" size="lg">
                    Registered Nurse
                  </Button>
                </div>
                <div className="p-2 col-lg-3 col-md-4 col-sm-6">
                  <Button variant="outline" color="gray" size="lg">
                    Healthcare Assistant
                  </Button>
                </div>
              </div>

              <div className="row mt-3">
                <h6>Work Patterns</h6>

                <div className="p-2 col-lg-3 col-md-3 col-sm-6">
                  {' '}
                  <Button variant="outline" color="gray" size="lg">
                    Full Time
                  </Button>
                </div>
                <div className="p-2 col-lg-3 col-md-3 col-sm-6">
                  {' '}
                  <Button variant="outline" color="gray" size="lg">
                    Part Time
                  </Button>
                </div>
                <div className="p-2 col-lg-3 col-md-3 col-sm-6">
                  {' '}
                  <Button variant="outline" color="gray" size="lg">
                    Days
                  </Button>
                </div>
                <div className="p-2 col-lg-3 col-md-3 col-sm-6">
                  {' '}
                  <Button variant="outline" color="gray" size="lg">
                    Nights
                  </Button>
                </div>
              </div>
              <div className="row mt-3">
                <h6>Driver</h6>
                <div className="p-2 col-lg-2 col-md-3 col-sm-6">
                  {' '}
                  <Button variant="outline" color="gray" size="lg">
                    Driver
                  </Button>
                </div>
                <div className="p-2 col-lg-2 col-md-3 col-sm-6">
                  <Button variant="outline" color="gray" size="lg">
                    Non-Driver
                  </Button>
                </div>
              </div>
              <JobsListComponent loading={loading} items={jobs} />
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/work">
                        Work with us
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/care">
                        How we deliver our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/training">
                        Testimonials
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/training">
                        Our values
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/training">
                        Complex care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 mt-5 mb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8"></div>
          </div>
        </div>
      </div>

      <CallToAction />
      <Footer />
    </div>
  );
}

export default JobsView;
